import React from "react";
import "./header.css";
import logoSM from "../../assets/images/LogoSM.png";
import logoSwitch from "../../assets/images/logoSwitch.png";
import ButtonForCall from "../../Components/ButtonForCall/ButtonForCall";
import { Link} from "react-router-dom";

function Header() {
  return (
    <header className="fixed-top w-100 d-flex justify-content-around align-items-center">
      <article 
      id="containerLogoSM" 
      className="d-none me-5">
          <Link
            to="/"
          >
             <img 
        src={logoSM} 
        alt="logo compteur-éléctricité"/>
          </Link> 
         
      </article>
      <article className="d-flex align-items-center">

      <ButtonForCall/>
      <section id="containerLogoSwitch" className="d-none ms-5">
        <a href="https://www.chezswitch.fr/" rel="noreferrer" target="_blank" >

        <img src={logoSwitch} alt="logo compteur-éléctricité"/>
        </a>
      </section>
      </article>
    </header>
  );
}

export default Header;